/**
 * This file was auto-generated by Fern from our API Definition.
 */

/**
 * All supported DID methods. Default is "web".
 */
export type PresentationSignRequestDidMethod = 'key' | 'web';
export const PresentationSignRequestDidMethod = {
    Key: 'key',
    Web: 'web',
} as const;
